import styles from './index.module.css'
import { useState } from "react";



function Spinner({ isLoading, message = 'Processando...' }) {
  if (!isLoading) {
    return null;
  }

  return (
    <div>
      {isLoading && (
        <div className={styles["loading-overlay"]}>
          <div className={styles["spinner"]}></div>
          <p>{message}</p>
        </div>
      )}
    </div>
  );
}

export default Spinner;
